import { ServiceType } from 'sections/Services/types';

export const servicesData: ServiceType[] = [
  {
    id: 1,
    heading: 'Trade Finance',
    description: 'DFA Members gain unparalleled access to timely financing. Through DP World Trade Finance you can access streamlined processes and cutting-edge technology to empower your business to be able to seize growth opportunities without delay.',
    url: '/services/trade-finance',
    iconName: 'money-bills-simple',
    alt: 'DF Alliance payment claims',
  },
  {
    id: 2,
    heading: 'Web Tools Integration',
    description: 'DFA has a dedicated IT Manager who can integrate the digital web tools available in your membership plan into your website at no additional cost.',
    url: '/digital-tools',
    iconName: 'network-wired',
    alt: 'DF Alliance network',
  },
  {
    id: 3,
    heading: 'Webinars & events',
    description: 'As a DFA member, you will be able to attend our annual offline conference and monthly online members’ meeting.',
    url: '/events',
    iconName: 'people-arrows-left-right-blue',
    alt: 'communication icon',
  },
  {
    id: 4,
    heading: 'Trainings for members ',
    description: "DFA training refers to educating your company's employees on the various benefits of your membership plan that will help you get the most out of your network.",
    url: '/events/members-meeting',
    iconName: 'people-arrows-left-right-red',
    alt: 'People icon',
  },
];